import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeControlComponent } from './time-control.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [TimeControlComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [TimeControlComponent],
})
export class TimeControlModule {}
